/**
 * Статические типы покупателя для фильтров отчётов
 */
export type CustomerTypeItem = {
  id: 'guest' | 'employee' | 'student'
  title: string
}

export const customerTypes: Array<CustomerTypeItem> = [
  { id: 'guest', title: 'Гость' },
  { id: 'employee', title: 'Сотрудники' },
  { id: 'student', title: 'Учащиеся' },
]
